'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const GiftcardsIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.3999 15.3C12.7999 14.4 13.7999 13.3 14.6999 12M14.6999 12C15.5999 13.4 16.6999 14.4 17.9999 15.3M14.6999 12V10.8M14.6999 12H13.4999C12.1999 12 11.0999 10.9 11.0999 9.60001C11.0999 8.90001 11.5999 8.40001 12.2999 8.40001C13.5999 8.40001 14.6999 9.50001 14.6999 10.8M14.6999 12H15.8999C17.1999 12 18.2999 10.9 18.2999 9.60001C18.2999 8.90001 17.7999 8.40001 17.0999 8.40001C15.7999 8.40001 14.6999 9.50001 14.6999 10.8M14.6999 12V18.2507M14.6999 10.8V5.75391M14.6999 18.2507H20.2464C20.8464 18.2507 21.2464 17.8507 21.2464 17.2507V12M14.6999 18.2507H3.77905C3.17905 18.2507 2.77905 17.8507 2.77905 17.2507L2.77905 12M14.6999 5.75391H3.77905C3.17905 5.75391 2.77905 6.15391 2.77905 6.75391L2.77905 12M14.6999 5.75391H20.2464C20.8464 5.75391 21.2464 6.15391 21.2464 6.75391L21.2464 12M2.77905 12H21.2464",
        stroke: "currentColor",
        strokeLinejoin: "round"
      }
    )
  }
);
const VpGiftcardsIcon = forwardRef(GiftcardsIcon);

export { VpGiftcardsIcon as default };
